import * as R from 'ramda'
import hostConf from '$config/frontend'

export const convertInviteLinkToReadableFormat = (link: string) =>
  `${hostConf.FRONT_HOST}/+${link}`

export const addTagToHallTags = (tag: string, tags: string[]) => {
  if (tags?.includes(tag)) return tags
  return (tags || []).concat(tag)
}

export const removeTagFromHallTags = (tag: string, tags: string[]) => {
  return R.without([tag], tags || [])
}
